const add = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Adds to current item or set. Creates a new item.",
    usage: "Do not use this icon to expand a collapsed area. Use the `expand` icon instead.",
    category: "Content",
    tags: ["plus", "create", "new"]
  },
  children: [{
    type: "path",
    props: {
      d: "M12.75 12.75h6.5a.749.749 0 1 0 0-1.5h-6.5v-6.5a.749.749 0 1 0-1.5 0v6.5h-6.5a.749.749 0 1 0 0 1.5h6.5v6.5a.749.749 0 1 0 1.5 0v-6.5z"
    }
  }]
};
export default add;